import { Avatar, Card, Colors, Text } from '@amelio/ui-library';

import type { User } from '@/types/directory/User';

import { getInitials, getProfilePictureUrl } from '@/utils/user';

interface EmployeeProfileCardProps {
    employee: User;
    jobTitle: string;
}

export const EmployeeProfileCard = ({ employee, jobTitle }: EmployeeProfileCardProps) => {
    const fullName = `${employee.firstName} ${employee.lastName}`.trim();

    return (
        <Card
            padding={'none'}
            bgColor={'bg-white/60'}
            className={'w-fit !rounded-[12px] backdrop-blur-[20px]'}
        >
            <div className={'ds-gap-lg ds-px-xl ds-py-lg flex items-center'}>
                <Avatar
                    alt={fullName}
                    src={getProfilePictureUrl(employee.profilePictureUrl ?? '')}
                    initials={getInitials(employee)}
                    size={'sm'}
                    variant={'circular'}
                    borderColor={Colors.WHITE}
                    borderSize={'ring-2'}
                    className={'!h-[56px] !w-[56px] shadow-sm'}
                />

                <div className={'flex flex-col gap-[2px]'}>
                    <Text
                        size={'large'}
                        weight={'semibold'}
                        color={Colors.BASE}
                        className={'!text-font-base'}
                    >
                        {fullName}
                    </Text>

                    {jobTitle && (
                        <Text
                            size={'small'}
                            weight={'medium'}
                            className={'!text-font-sm text-primary'}
                        >
                            {jobTitle}
                        </Text>
                    )}
                </div>
            </div>
        </Card>
    );
};
